<div>
  <h4>Search for VCC</h4>
  <mat-form-field class="selection-input" appearance="fill">
    <mat-label>VCC Name</mat-label>
    <input matInput
           [formControl]="inputFormControl"
           [matAutocomplete]="auto"
           data-test="NewRequestTextInput">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
      <mat-option *ngFor="let option of typeAheadOptions" [value]="option">
        {{ option.vccName }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="inputFormControl.hasError('invalidVcc')">
      Select a valid VCC.
    </mat-error>
    <mat-error *ngIf="inputFormControl.hasError('required')">
      This field is required.
    </mat-error>
  </mat-form-field>
</div>
<hr>
<div class="info-display" data-test="NewRequestInfoDisplay">
  <h3>Confirm this is the correct category:</h3>
  <p><strong>VCC Name:</strong> {{ selectedOption?.vccName }}</p>
</div>
